'use client'
import React, { ReactNode } from 'react'
import classNames from 'classnames'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export type BulletType = 'plus' | 'check' | 'arrow-right' | 'statistic-2' | 'disaster-recovery'

type ListItem = {
  title: string
  href?: string
}

type Props = {
  stripped?: boolean
  scattered?: boolean
  bulletType?: BulletType
  items?: ListItem[]
  className?: string
  children?: Array<ReactNode>
  childClasses?: string
}

export const List = ({
  stripped = false,
  scattered = false,
  bulletType = undefined,
  items,
  className,
  children = [],
  childClasses,
}: Props) => {
  const pathname = usePathname()
  const listClassArray: string[] = []

  if (stripped) {
    listClassArray.push('ul-stripped')
  }

  if (scattered) {
    listClassArray.push('ul-scattered')
  }

  if (bulletType && !stripped) {
    listClassArray.push(`ul-${bulletType}`)
  }

  return (
    <ul
      className={classNames(
        'u-fs-14',
        className,
        {
          'ul-stripped': stripped,
          'ul-scattered': scattered,
        },
        listClassArray
      )}>
      {children.length > 0
        ? children.map((child: ReactNode, index: number) => {
            return (
              <li className={childClasses} key={index}>
                {child}
              </li>
            )
          })
        : items?.map((item, index) => {
            return item.href ? (
              <li
                key={index}
                className={`${
                  pathname === item.href ? 'u-fw-bold ' : ''
                } ${childClasses} u-c-pointer`}>
                <Link prefetch={false} href={item.href} className="u-decoration-none">
                  {item.title}
                </Link>
              </li>
            ) : (
              <li key={index}>{item.title}</li>
            )
          })}
    </ul>
  )
}

export default List
